/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import template from './test-style-page.component.html';

@Component({
  standalone: false,
  selector: 'adn-test-style-page',
  template
})
export class TestStylePageComponent {
}
